module.exports = __webpack_public_path__ + "assets/TB-DB_icon_medical_information_black_24dp.svg";